import clsx from 'clsx'
import React, { FC } from 'react'

import { Loading } from '@Components/CMS/Video/index'

interface WistiaProps{
  classes: string | undefined
  videoId: string
  videoLoaded: boolean
}

export const WistiaVideoContainer: FC<WistiaProps> = ({ classes, videoId, videoLoaded }) => (
  <div className={clsx('wistiaResponsivePadding', classes)}>
    <div className="wistia_responsive_wrapper">
      <div
        className={clsx(
          'wistia_embed',
          `wistia_async_${videoId}`,
          'videoFoam=true',
          'wistiaVideo',
        )}
      />
    </div>
    {!videoLoaded && <Loading />}
  </div>
)
